import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import compassImage from '../../assets/meo_aventurier.png';
import { IoIosArrowBack } from "react-icons/io";
import {
  Container,
  ContentWrapper,
  LogoImage,
  PrimaryButton,
  ChatBubbleContainer,
  ChatText 
} from './styles';
import { ReturnButton } from '../Onboarding/styles';

const MessagePret = () => {
  const [isTyping, setIsTyping] = useState(true);
  const [text, setText] = useState('');
  const fullText = "Super ! Tu es prêt à rentrer dans la jungle de l'orientation avec moi ?";
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        setIsTyping(false);
        clearInterval(typingInterval);
      }
    }, 15);

    return () => clearInterval(typingInterval);
  }, []);

  const handleBack = () => {
    navigate('/subdomaine-formation');
  };

  const handleSubmit = () => {
    if (isTyping) return;
    setIsLoading(true);
    try {
      // Navigate to first-login
      navigate('/origine-city');
    } catch (error) {
      console.error('Error during navigation:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <ContentWrapper>
        <ReturnButton onClick={handleBack}>
          <IoIosArrowBack />
        </ReturnButton>

        <ChatBubbleContainer>
          <ChatText isVisible={text.length > 0}>
            {text}
          </ChatText>
        </ChatBubbleContainer>

        <LogoImage src={compassImage} alt="Compass Logo" />
        
        <PrimaryButton
          onClick={handleSubmit}
          disabled={isTyping || isLoading}
          style={{
            opacity: (isTyping || isLoading) ? 0.5 : 1,
            cursor: (isTyping || isLoading) ? 'not-allowed' : 'pointer'
          }}
        >
          Allons-y !
        </PrimaryButton>
      </ContentWrapper>
    </Container>
  );
};

export default MessagePret;